module.exports = __webpack_public_path__ + "img/land-bg.4bda29ad.png";